export const getLoginAPIURL = () => {
    const Confdata = window['runConfig'];
    return Confdata;
}